export default "__VITE_ASSET__d18aeda1__"